"use strict";

import spexecutorApi from "@/api/spexecutor";
import store from "../index";
import { encrypt, decrypt } from "../encrypt";
import SecureLS from "secure-ls";
import router from "../../router";
const ls = new SecureLS({ encodingType: "aes" });

export default {
  actions: {
    prosesRequestSpExecutor(context, payload) {
      return new Promise((resolve, reject) => {
        var isEncrypt = process.env.VUE_APP_ENCRYPT;
        var payloadEncrypt = isEncrypt ? encrypt(payload) : payload;
        let token = store.getters.token;
        spexecutorApi
          .prosesRequestSpExecutor(payloadEncrypt, token)
          .then((response) => {
            var message =
              response.data.Message != null && resolve.data.Message != undefined
                ? resolve.data.Message
                : "";
            var res = response;
            if (message.includes("Token")) {
              ls.set("token", true);
              router.push("/");
            } else {
              const data =
                isEncrypt == "false" ? response : decrypt(response.data.data);
              res = isEncrypt == "false" ? data : { data: data };
              resolve(res);
            }
            // console.log(response)
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    prosesRequestTnC(context, payload) {
      return new Promise((resolve, reject) => {
        var isEncrypt = process.env.VUE_APP_ENCRYPT;
        var payloadEncrypt = isEncrypt ? encrypt(payload) : payload;
        let token = store.getters.token;
        spexecutorApi
          .prosesRequestSpExecutor(payloadEncrypt, token)
          .then((response) => {
            console.log('RESPONSE SPEXEC ==>', response);
            console.log("MESSAGE ==>", response.data.Message);
            var message =
              response.data.Message != null && response.data.Message != undefined
                ? response.data.Message
                : "";
            console.log('MESSAGE ==>', message);
            var res = response;
            if (message.includes("Token")) {
              ls.set("token", true);
              resolve(res);
            } else {
              const data =
                isEncrypt == "false" ? response : decrypt(response.data.data);
              res = isEncrypt == "false" ? data : { data: data };
              resolve(res);
            }
            // console.log(response)
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
